import React from "react";
import { Link } from "react-router-dom";

export default function Homeabout() {
  return (
    <div>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">
                  About Us
                </h5>
                <h1 className="mb-0">
                  Empowering Businesses with Growth-Driven Sales & Lead
                  Solutions
                </h1>
              </div>
              <p className="mb-4">
                At My Easy Tax Pro Partners, we specialize in helping businesses
                grow smarter through powerful sales and lead generation
                strategies. Our goal is simple — to connect you with the right
                customers and boost your business performance.
              </p>
              <p className="mb-4">
                Through a blend of strategic planning, market insights, and
                advanced digital tools, our team delivers measurable results
                that accelerate business growth. We focus on optimizing lead
                generation, enhancing customer engagement, and improving
                conversion rates through performance-driven marketing campaigns.
                Every solution is customized to align with your goals — helping
                you attract qualified leads, strengthen customer relationships,
                and achieve sustainable business success.
              </p>

              <Link
                to="/about"
                className="btn btn-primary py-3 px-5 mt-3 wow zoomIn"
                data-wow-delay="0.9s"
              >
                Know More
              </Link>
            </div>
            <div className="col-lg-5" style={{ minheight: "500px" }}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-500 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src="assets/img/mpphabout.png"
                  style={{ objectfit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
